import React, { Dispatch, SetStateAction } from 'react';
import { Box } from '@mui/material';
import { theme } from "src/theme/mui-theme";
import { ts } from "src/utils/translate";
import { UserInfoResponse } from "src/model/api/get-user-info-response.model";

interface UpgradeButtonProps {
    userInfo?: UserInfoResponse
    setIsSubscriptionModalOpen: Dispatch<SetStateAction<boolean>>
}

function UpgradeButton({ userInfo, setIsSubscriptionModalOpen }: UpgradeButtonProps) {
    const getBackgroundColor = () => {
        if (userInfo?.hasPro && Number(userInfo?.daysLeft) <= 3) {
            return 'orange';
        }

        if (userInfo?.hasPro) {
            return theme.palette.primary.main;
        }

        return '#ff4444';
    };

    return (
        userInfo == null ? null :
            <Box
                sx={{
                  height: '38px',
                  paddingX: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: getBackgroundColor(),
                  color: 'white',
                  borderRadius: 2,
                  cursor: 'pointer',
                  fontSize: '14px',
                  textAlign: 'center',
                  transition: 'background-color 0.3s',
                  '&:hover': {
                    opacity: 0.8,
                  },
                  marginRight: '32px',
                }}
                onClick={() => setIsSubscriptionModalOpen(true)}
            >
              {!userInfo?.hasPro || Number(userInfo.daysLeft) <= 3 ? (
                  ts("upgrade_to_pro_button", "Upgrade to Pro")
              ) : (
                  ts("pro_package_button", "Pro package")
              )}
            </Box>

    );
};

export default UpgradeButton;